module.exports = __webpack_public_path__ + "static/img/cg2.c0745e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cg2.png
// module id = Rvkt
// module chunks = 1